/* eslint-disable max-len,react/require-default-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import DateTimePicker from 'react-datetime-picker';
import DatePicker from 'react-date-picker';
import Popup from "./Popup.js";
import Theme from "./Theme.js";
import ToggleButton from "./ToggleButton.js";
import Button from "./Button.js";
import S from './DateTimePickerV2.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class DateTimePickerActual extends React.Component {
  constructor(props) {
    super(props);
    const {
      value
    } = props;
    this.state = {
      calendarOpened: false,
      value
    };
    this.calendarRef = /*#__PURE__*/React.createRef();
    this.buttonRef = /*#__PURE__*/React.createRef();
  }
  static contextType = Theme.Context;
  static propTypes = {
    onChange: PropTypes.func,
    eventData: PropTypes.any,
    value: PropTypes.instanceOf(Date),
    variant: PropTypes.string,
    className: PropTypes.string,
    calendarClassName: PropTypes.string,
    calendarIcon: PropTypes.node,
    calendarButtonVariant: PropTypes.string,
    clearIcon: PropTypes.node,
    clearButtonVariant: PropTypes.string,
    open: PropTypes.bool
  };
  static defaultProps = {
    onChange: null,
    eventData: undefined,
    value: null,
    variant: undefined,
    className: undefined,
    calendarClassName: undefined,
    calendarIcon: undefined,
    clearIcon: undefined,
    open: undefined
  };
  static getDerivedStateFromProps(props) {
    if (props && props.open != null) {
      return {
        calendarOpened: props.open
      };
    }
    return null;
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.onClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onClickOutside);
  }
  onClickOutside = evt => {
    const isInCalendar = this.calendarRef?.current && this.calendarRef.current.contains(evt.target);
    const isInButtons = this.buttonRef?.current && this.buttonRef.current.contains(evt.target);
    if (!isInCalendar && !isInButtons) {
      this.setState({
        calendarOpened: false
      });
    }
  };
  onChange = value => {
    this.setState({
      value
    });
    if (value == null) {
      this.buttonRef.current?.focus();
    }
  };
  onChangeDate = value => {
    const {
      value: pValue
    } = this.state;
    const nDate = new Date(value);
    if (pValue != null) {
      nDate.setHours(pValue.getHours());
      nDate.setMinutes(pValue.getMinutes());
      nDate.setSeconds(pValue.getSeconds());
    }
    this.setState({
      calendarOpened: false,
      value: nDate
    });
    this.buttonRef.current?.focus();
  };
  onCalendarToggled = evt => {
    const {
      value
    } = evt || {};
    const {
      calendarOpened
    } = this.state;
    const toggleValue = value != null ? value : !calendarOpened;
    this.setState({
      calendarOpened: toggleValue
    });
  };
  onBlur = evt => {
    if (evt.currentTarget.contains(evt.relatedTarget) || this.calendarRef.current?.contains(evt.relatedTarget)) {
      evt.stopPropagation();
    } else {
      const {
        onChange,
        eventData
      } = this.props;
      const {
        value
      } = this.state;
      if (typeof onChange === 'function') {
        onChange({
          data: eventData,
          value
        });
      }
    }
  };
  renderPopup = () => {
    const theme = this.context;
    const {
      variant
    } = this.props;
    const {
      value
    } = this.state;
    const {
      calendarClassName,
      calendarProps,
      className
    } = theme.props('DateTimePickerV2', variant, this.props);
    const cn = theme.classes('DateTimePickerV2', 'dateTimePicker', variant, className);
    const calendarCn = theme.subclasses('DateTimePickerV2', 'calendar', calendarClassName);
    return /*#__PURE__*/_jsx("div", {
      className: cn,
      ref: this.calendarRef,
      children: /*#__PURE__*/_jsx(Calendar, {
        ...calendarProps,
        className: calendarCn,
        value: value,
        onChange: this.onChangeDate
      })
    });
  };
  renderTrigger = ({
    ref
  }) => {
    const theme = this.context;
    const {
      calendarOpened,
      value
    } = this.state;
    const {
      variant
    } = this.props;
    const {
      eventData,
      onChange,
      className,
      calendarIcon = 'fa fa-calendar fa-fw',
      clearIcon = 'fa fa-close fa-fw',
      calendarProps,
      calendarClassName,
      inputClassName,
      variant: ignoreVariant,
      clearButtonVariant,
      calendarButtonVariant,
      disabled,
      style,
      wrapperStyle,
      time = true,
      ...rest
    } = theme.props('DateTimePickerV2', variant, this.props);
    const cn = theme.classes('DateTimePickerV2', 'dateTimePicker', variant, className);
    const baseCn = theme.subclasses('DateTimePickerV2', 'base', disabled ? 'disabled' : undefined);
    const inputCn = theme.subclasses('DateTimePickerV2', 'input', inputClassName, S.input);
    return /*#__PURE__*/_jsx("div", {
      className: cn,
      ref: ref,
      style: wrapperStyle,
      tabIndex: 0,
      role: "button",
      onBlur: this.onBlur,
      children: /*#__PURE__*/_jsxs("div", {
        className: baseCn,
        style: {
          display: 'inline-flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...(style || {})
        },
        children: [/*#__PURE__*/_jsx(ToggleButton, {
          domRef: this.buttonRef,
          value: calendarOpened,
          variant: calendarButtonVariant,
          icon: calendarIcon,
          onChange: this.onCalendarToggled,
          disabled: disabled
        }), time ? /*#__PURE__*/_jsx(DateTimePicker, {
          maxDetail: "second",
          onChange: this.onChange,
          ...rest,
          value: value,
          className: inputCn,
          clearIcon: null,
          disableClock: true,
          disableCalendar: true,
          disabled: disabled
        }) : /*#__PURE__*/_jsx(DatePicker, {
          onChange: this.onChange,
          ...rest,
          value: value,
          className: inputCn,
          clearIcon: null,
          disableCalendar: true,
          disabled: disabled
        }), value != null && /*#__PURE__*/_jsx(Button, {
          tabIndex: -1,
          icon: clearIcon,
          variant: clearButtonVariant,
          onClick: () => this.onChange(null),
          disabled: disabled
        })]
      })
    });
  };
  render() {
    const {
      calendarOpened
    } = this.state;
    const {
      variant
    } = this.props;
    return /*#__PURE__*/_jsx(Popup, {
      variant: variant,
      opened: calendarOpened,
      render: this.renderPopup,
      trigger: this.renderTrigger
    });
  }
}
export default function DateTimePickerV2(props) {
  const {
    value,
    ...rest
  } = props;
  const val = useMemo(() => {
    if (value == null) {
      return value;
    }
    let date;
    if (typeof value === 'string' || typeof value === 'number') {
      date = new Date(value);
    } else {
      date = value;
    }
    if (Number.isNaN(date?.getTime?.())) {
      return null;
    }
    return date;
  }, [value]);
  return /*#__PURE__*/_jsx(DateTimePickerActual, {
    ...rest,
    value: val
  });
}